module.exports = __webpack_public_path__ + "img/huawei-bk.19f370d0.svg";